export const backgroundElementQuery = `
   query backgroundElement($canonicalUid: [String]) {
        ds_BackgroundElementsEntries(uid: $canonicalUid) {
            ... on ds_BackgroundElement_Entry {
                id
                backgroundElement_Image {
                    alt
                    url @transform(width: 1920)
                    urlOriginal: url
                    width
                    focalPoint
                    mimeType
                }
                backgroundElement_Opacity
                backgroundElement_Placement
                backgroundElement_Size
                backgroundElement_ScaleWidth
                backgroundElement_ScaleHeight
                backgroundElement_HorizontalAdjustment
                backgroundElement_VerticalAdjustment
            }
        }
    }

`
